import React, { useRef } from 'react'
import styles from './DragDrop.module.css'

const DragDropArea = ({ onSelect, acceptedFiles }) => {
  const inputRef = useRef(null)

  const handleButtonClick = () => {
    if (inputRef.current) {
      requestAnimationFrame(() => {
        inputRef.current.click()
      })
    }
  }

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || [])
    if (files.length > 0) {
      onSelect(files)
    }
  }

  return (
    <div className={`${styles.dragDropContainer}`}>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={acceptedFiles}
        onChange={handleFileChange}
        data-testid={'UpdateSiteModal-selectedfile-dragdroparea-input'}
        style={{ display: 'none' }}
      />
      <div className={styles.contentContainer}>
        <p className={styles.dragText}>Drag and drop more files or</p>

        <button type="button" className={styles.uploadButton} onClick={handleButtonClick}>
          Choose files to upload
        </button>
      </div>
    </div>
  )
}

export default DragDropArea
